import { arrayOf, bool, string, shape, number } from "prop-types";

import cx from "classnames";
import Promo from "./../Promo/Promo.jsx";

const propTypes = {};

const FeaturedItem = (props) => {
  const { eyebrow, title, images, body, link, readTime } = props;

  return (
    <div className="dynamic-content-listing__featured-item">
      <Promo
        eyebrow={eyebrow}
        title={title}
        image={{
          imageXSmall: images.mobile1X,
          imageSmall: images.desktop1X,
          imageMedium: images.mobile2X,
          imageLarge: images.desktop2X,
        }}
        description={body}
        readTime={readTime}
        fromNewsStories={true}
      />
    </div>
  );
};

// Specifies the default values for props:
FeaturedItem.defaultProps = {};

FeaturedItem.propTypes = propTypes;
export default FeaturedItem;
